import { MODULE_ACL, USER_ROLES } from './constant';
import { getUser } from './setting';
import { parseModuleOperations } from './voicePlanAcl';

/**
 * Contacts → Options → "Custom fields". Mirrors the backend
 * shared/utils/common/contacts-acl.js: opt-in, so a Contacts entry without
 * edit_options means the option is off.
 */
export const CONTACTS_ACL_MODULE = MODULE_ACL.CONTACTS;
export const CONTACT_CUSTOM_FIELDS_ACL_OPTION = 'custom_fields';

interface ContactsModuleEntry {
  read?: boolean;
  add?: boolean;
  edit?: boolean;
  edit_options?: unknown;
}

type ModuleOperations = Record<string, ContactsModuleEntry | undefined>;

export function normalizeContactsEditOptions(options: unknown): string[] {
  if (!Array.isArray(options)) return [];
  return [...new Set(options.map((o) => String(o).trim()))].filter(
    (o) => o === CONTACT_CUSTOM_FIELDS_ACL_OPTION,
  );
}

export function isContactsCustomFieldsRelevant(entry: ContactsModuleEntry | null | undefined): boolean {
  return !!(entry && (entry.read || entry.add || entry.edit));
}

export function entryHasContactCustomFields(entry: ContactsModuleEntry | null | undefined): boolean {
  if (!isContactsCustomFieldsRelevant(entry)) return false;
  return normalizeContactsEditOptions(entry?.edit_options).includes(CONTACT_CUSTOM_FIELDS_ACL_OPTION);
}

export function formatContactCustomFieldsAclLabel(entry: ContactsModuleEntry | null | undefined): string {
  return entryHasContactCustomFields(entry) ? 'Custom fields' : '—';
}

/** Whether the logged-in user has the Custom fields option (Super Admin always). */
export function currentUserHasContactCustomFields(): boolean {
  const user = getUser();
  if (user?.role === USER_ROLES.SUPERADMIN) return true;
  const ops = parseModuleOperations(user?.acl_settings?.module_operations) as ModuleOperations;
  return entryHasContactCustomFields(ops?.[CONTACTS_ACL_MODULE]);
}

/** ACL editor: edit_options to save for a Contacts entry, clamped to what the editor can grant. */
export function normalizeContactsAclForSave(entry: ContactsModuleEntry | null | undefined, canGrant: boolean): string[] {
  if (!canGrant) return [];
  return normalizeContactsEditOptions(entry?.edit_options);
}
